import type { OnPageTransitionStartAsync } from "vike/types";
import { useLoadingStore } from '@/stores/loading'
import { useNavStore } from "@repo/ui";

export const onPageTransitionStart: OnPageTransitionStartAsync = async () => {
  console.log("Page transition start");
  const loadingStore = useLoadingStore()
  loadingStore.start()

  const navStore = useNavStore();
  navStore.setPreviousUrl(window.location.href);

  document.querySelector("body")?.classList.add("page-is-transitioning");
};
